<div class="observation-species-item" [routerLink]="['/profile', userId, 'species', species, 'year', year]">
  <!-- <div class="observation-species-item__image-container"> -->
  <img class="observation-species-item__image" data-test-id="observation-species-item__image" [src]="getIconPath()" />
  <!-- </div> -->
  <div class="observation-species-item__description">
    <div class="observation-species-item__name">
      <div class="observation-species-item__label" data-test-id="observation-species-item__species" translate>
        Gruppe
      </div>
      <div class="observation-species-item__value" data-test-id="observation-species-item_name">
        {{ getSpecies().de | translate }}
      </div>
    </div>
    <div class="observation-species-item__observation">
      <div class="observation-species-item__label" *ngIf="getLastObservationDate()">
        {{ 'Letzte Beobachtung' | translate }},
        {{ getLastObservationDate() }}
      </div>
      <div class="observation-species-item__label" *ngIf="!getLastObservationDate()">
        {{ 'Noch keine Beobachtungen' | translate }}
      </div>
    </div>
  </div>
  <div class="observation-species-item__quantity-container">
    <div class="observation-species-item__quantity">{{ items.length }}</div>
  </div>
  <mat-icon svgIcon="arrow-right"></mat-icon>
</div>
